// DocumentUpload.tsx
import React, { useState } from 'react';

interface DocumentUploadProps {
  onBack: () => void;
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({ onBack }) => {
  const [titlu, setTitlu] = useState<string>('');
  const [descriere, setDescriere] = useState<string>('');
  const [categorie, setCategorie] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>('');

  // Categorii disponibile
  const categorii = [
    { id: '', nume: 'Selectează o categorie' },
    { id: 'fonduri', nume: 'Fonduri și finanțări' },
    { id: 'modele', nume: 'Modele și template-uri' },
    { id: 'legislatie', nume: 'Legislație' },
    { id: 'rapoarte', nume: 'Rapoarte și analize' },
    { id: 'formulare', nume: 'Formulare' },
  ];

  // Simularea încărcării fișierului
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setFileName(file.name);
    }
  };

  // Simularea trimiterii formularului
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!titlu || !descriere || !categorie || !selectedFile) {
      alert('Te rugăm să completezi toate câmpurile și să selectezi un fișier.');
      return;
    }
    
    alert(`Document simulat încărcat cu succes!\nTitlu: ${titlu}\nCategorie: ${categorie}\nFișier: ${fileName}`);
    onBack();
  };

  return (
    <div className="bg-white rounded-lg shadow">
      {/* Header */}
      <div className="p-4 border-b flex items-center">
        <button 
          onClick={onBack}
          className="mr-3 text-gray-600 hover:text-blue-600"
        >
          ← Înapoi
        </button>
        <h1 className="text-xl font-semibold">Încarcă un document nou</h1>
      </div>

      {/* Formular */}
      <div className="p-6">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Titlu document*</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md"
              placeholder="Introdu titlul documentului"
              value={titlu}
              onChange={(e) => setTitlu(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Descriere*</label>
            <textarea
              className="w-full p-2 border rounded-md h-32"
              placeholder="Oferă o descriere pentru document"
              value={descriere}
              onChange={(e) => setDescriere(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Categorie*</label>
            <select
              className="w-full p-2 border rounded-md bg-white"
              value={categorie}
              onChange={(e) => setCategorie(e.target.value)}
              required
            >
              {categorii.map((cat) => (
                <option key={cat.id} value={cat.id}>{cat.nume}</option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">Fișier*</label>
            <div className="border rounded-md p-4 bg-gray-50">
              <div className="flex flex-col items-center justify-center">
                <div className="text-4xl mb-2">📄</div>
                <p className="mb-4 text-center text-gray-600">
                  {fileName ? fileName : "Trage și plasează fișierul aici sau apasă pentru a selecta"}
                </p>
                <input
                  type="file"
                  id="fileUpload"
                  className="hidden"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                />
                <label
                  htmlFor="fileUpload"
                  className="bg-blue-100 hover:bg-blue-200 text-blue-700 px-4 py-2 rounded-md font-medium cursor-pointer"
                >
                  Selectează fișier
                </label>
                <p className="mt-2 text-xs text-gray-500">
                  Formate acceptate: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onBack}
              className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-md font-medium"
            >
              Anulează
            </button>
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium"
            >
              Încarcă document
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DocumentUpload;